import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useContext, useMemo } from 'react';
import { BodyContainer } from '../../../../elements/Common';
import { RouteTabs } from '../../../../components';
import { CommonUtility, Tabs } from '../../../../utility';
import { useSecondaryHeader } from '../../../../hooks/useSecondaryHeader';
import { OrdersTabExtraContext } from '../../../../contexts/orders-tab-extra';
import { OrderListTab } from './order-list';
import { TrackingTab } from './tracking';

function OrdersSecondaryHeader({ menus, currentTab, tabClicked }) {
  const { tabExtra } = useContext(OrdersTabExtraContext);

  return (
    <RouteTabs
      items={menus}
      activeKey={currentTab}
      onChange={tabClicked}
      tabBarExtraContent={tabExtra}
    />
  );
}

function OrderListScreenContent() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const currentTab = useMemo(() => {
    if (pathname) {
      return CommonUtility.getSegmentByPosition(pathname, 4);
    }
    return null;
  }, [pathname]);

  const tabClicked = tabName => {
    navigate(`/app/fulfill/orders/${tabName}`);
  };

  const menus = [
    {
      text: 'Pending Fulfillment',
      value: Tabs.OrderTabs.pendingFulfillment,
    },
    {
      text: 'Paused',
      value: Tabs.OrderTabs.paused,
    },
    {
      text: 'Shipped',
      value: Tabs.OrderTabs.shipped,
    },
    {
      text: 'Tracking',
      value: Tabs.OrderTabs.tracking,
    },
  ];

  useSecondaryHeader(
    () => (
      <OrdersSecondaryHeader
        menus={menus}
        currentTab={currentTab}
        tabClicked={tabClicked}
      />
    ),
    [currentTab, tabClicked],
  );

  return (
    <BodyContainer className="tab-layout no-header">
      <Routes>
        <Route index element={<Navigate to={Tabs.OrderTabs.pendingFulfillment} />} />
        <Route path={Tabs.OrderTabs.tracking} element={<TrackingTab />} />
        <Route path="*" element={<OrderListTab />} />
      </Routes>
    </BodyContainer>
  );
}

export function OrderListScreen() {
  return <OrderListScreenContent />;
}
